import { useEffect } from 'react';
import { useEffectEvent } from 'use-effect-event';
import { useLogout } from '../account/localLogout';

const useDesktopLogout = () => {
  const logout = useLogout();
  const logoutEvent = useEffectEvent(logout);

  useEffect(() => window.desktop?.onRequestLogout?.(() => logoutEvent()), []);
};

export default useDesktopLogout;
